import { useEffect, useState } from 'react'
import { Truck, RefreshCw, MapPin, Clock } from 'lucide-react'

interface DPDData {
  totalShipments: number
  inTransit: number
  delivered: number
  recentShipments: Array<{
    id: string
    tracking: string
    destination: string
    status: string
    date: string
  }>
}

export default function DPDPage() {
  const [data, setData] = useState<DPDData | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchDPDData()
  }, [])

  const fetchDPDData = async () => {
    setLoading(true)
    // TODO: Implementar chamada real à API do DPD
    setTimeout(() => {
      setData({
        totalShipments: 0,
        inTransit: 0,
        delivered: 0,
        recentShipments: []
      })
      setLoading(false)
    }, 1000)
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black"></div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">DPD</h1>
          <p className="text-gray-600 mt-1">Gestão de envios e rastreamento</p>
        </div>
        <button
          onClick={fetchDPDData}
          className="flex items-center gap-2 px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-900 transition"
        >
          <RefreshCw className="w-4 h-4" />
          Atualizar
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Total de Envios</p>
              <p className="text-2xl font-bold text-gray-900 mt-2">{data?.totalShipments || 0}</p>
            </div>
            <Truck className="w-8 h-8 text-yellow-500" />
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Em Trânsito</p>
              <p className="text-2xl font-bold text-gray-900 mt-2">{data?.inTransit || 0}</p>
            </div>
            <Clock className="w-8 h-8 text-blue-500" />
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Entregues</p>
              <p className="text-2xl font-bold text-gray-900 mt-2">{data?.delivered || 0}</p>
            </div>
            <MapPin className="w-8 h-8 text-green-500" />
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow">
        <div className="p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">Envios Recentes</h2>
        </div>
        <div className="p-6">
          {data?.recentShipments.length === 0 ? (
            <p className="text-gray-500 text-center py-8">Nenhum envio encontrado</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="text-left text-gray-600 border-b">
                    <th className="pb-3">ID</th>
                    <th className="pb-3">Tracking</th>
                    <th className="pb-3">Destino</th>
                    <th className="pb-3">Status</th>
                    <th className="pb-3">Data</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.recentShipments.map((shipment) => (
                    <tr key={shipment.id} className="border-b">
                      <td className="py-3">{shipment.id}</td>
                      <td className="py-3 font-mono text-sm">{shipment.tracking}</td>
                      <td className="py-3">{shipment.destination}</td>
                      <td className="py-3">
                        <span className={`px-2 py-1 rounded text-sm ${
                          shipment.status === 'Entregue' 
                            ? 'bg-gray-100 text-black' 
                            : 'bg-gray-100 text-black'
                        }`}>
                          {shipment.status}
                        </span>
                      </td>
                      <td className="py-3">{shipment.date}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
